import { isDev } from "./config";
type LogLevel = "debug" | "warn" | "error";

interface LogFunction {
  (message: string, ...optionalParams: any[]): void;
}

interface Log {
  debug: LogFunction;
  warn: LogFunction;
  error: LogFunction;
}

export const log: Log = {
  debug: createLogFunction("debug", console.log),
  warn: createLogFunction("warn", console.warn),
  error: createLogFunction("error", console.error),
};

export function bindLoggers() {
  log.debug = createLogFunction("debug", console.log);
  log.warn = createLogFunction("warn", console.warn);
  log.error = createLogFunction("error", console.error);
}

bindLoggers();

function createLogFunction(
  level: LogLevel,
  consoleFunction: (...data: any[]) => void
): LogFunction {
  const colorMap = new Map<string, string>();

  function getColor(prefix: string): string {
    if (!colorMap.has(prefix)) {
      // Generate a random color
      const color = `#${Math.floor(Math.random() * 0xffffff)
        .toString(16)
        .padStart(6, "0")}`;
      colorMap.set(prefix, color);
    }
    return colorMap.get(prefix)!;
  }

  return (message: string, ...optionalParams: any[]) => {
    if (typeof message === "string") {
      let color = "#888";

      switch (level) {
        case "error":
          color = "#99333";
          message = "%c" + message;
          break;
        case "warn":
          color = "#339999";
          message = "%c" + message;
          break;
        case "debug":
          if (!isDev() && !(window as any).debug) {
            return;
          }
          const match = message.match(/^\[(.+?)\]/);
          if (match) {
            const prefix = match[1];
            color = getColor(prefix);
            message = message.replace(`[${prefix}]`, `%c[${prefix}]%c`);
          }
          break;
      }

      consoleFunction(
        message,
        `color: ${color}`,
        "color: inherit",
        ...optionalParams
      );
    } else {
      consoleFunction(message, ...optionalParams);
    }
  };
}
